<template>
    <v-app-bar
        color="white elevation-2"
        app
        fixed
        clipped-left
        extended
        extension-height="0"
    >
        <v-app-bar-nav-icon v-if="loggedIn" @click="toggleDrawer" />
        <router-link :to="{name: 'dashboard'}" class="d-flex ml-3">
            <img src="@/assets/images/colours-factory-logo.svg" class="logo">
        </router-link>
        <v-chip
            v-if="isStaging"
            class="ma-2"
            color="red"
            text-color="white"
        >
            ŚRODOWISKO STAGE
        </v-chip>
        <v-spacer />
        <span v-if="loggedIn" class="mr-3 hidden-xs-only">
            {{ $t('user.welcomeMessage') }}, {{ userName }}!
        </span>
        <v-menu v-if="loggedIn" bottom left>
            <template #activator="{on}">
                <v-btn
                    dark
                    color="secondary"
                    fab
                    small
                    class="elevation-0"
                    v-on="on"
                >
                    <v-icon color="white">
                        mdi-account
                    </v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-list subheader>
                    <v-list-item>
                        <v-list-item-avatar>
                            <v-avatar dark color="secondary" size="32px">
                                <v-icon color="white">
                                    mdi-account
                                </v-icon>
                            </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t('user.welcomeMessage') }}, {{ userName }}!</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider />
                <v-list subheader>
                    <v-subheader>Konto</v-subheader>
                    <v-list-item @click="openChangePasswordDialog">
                        <v-list-item-title>Zmiana hasła</v-list-item-title>
                    </v-list-item>
                </v-list>

                <v-divider />

                <v-list>
                    <v-list-item @click="logout">
                        <v-list-item-title>Wyloguj</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        <v-progress-linear
            slot="extension"
            absolute
            :active="mainLoader"
            :indeterminate="true"
            class="ma-0"
            height="4"
            style="top: -2px"
        />
    </v-app-bar>
</template>

<script>
export default {
    props: {
        drawer: {
            type: Boolean
        },
        mainLoader: {
            type: Boolean
        }
    },
    computed: {
        loggedIn() {
            return this.$store.getters.loggedIn
        },
        userName() {
            return this.$store.state.user.userName
        },
        isStaging() {
            return process.env.VUE_APP_ENV === 'staging'
        }
    },
    methods: {
        toggleDrawer() {
            this.$emit('toggle-drawer', !this.drawer)
        },
        openChangePasswordDialog() {
            this.$emit('open-change-password-dialog')
        },
        logout() {
            this.$store.dispatch('logout')
            this.$router.replace({ name: 'userLogin' })
        }
    }
}
</script>
